module.exports = __webpack_public_path__ + "static/img/dollarmds.bba3cdc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dollarmds.svg
// module id = 849
// module chunks = 2 3 4 5